import { TextField } from '@mui/material';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import DefaultDialog, { Action } from '../DefaultDialog';

interface Props {
	close: () => void;
	handleConfirm: (key: string, value: string) => Promise<boolean>;
	entityLocator: string;
	title: string;
	isOpen: boolean;
	editKey?: string;
	editValue?: string;
}

const AuxDataModal = (props: Props) => {
	const { title, isOpen, close, editKey, editValue, handleConfirm } = props;
	const [createKey, setCreateKey] = useState(editKey ? editKey : '');
	const [createValue, setCreateValue] = useState(editValue ? editValue : '');
	const [loading, setLoading] = useState(false);
	const isFormValid = editKey ? true : !!createKey?.trim();

	useEffect(() => {
		if (isOpen) {
			setCreateKey(editKey ? editKey : '');
			setCreateValue(editValue ? editValue : '');
		}
	}, [isOpen, editValue]);

	const closeAndClear = () => {
		close();
		setCreateKey('');
		setCreateValue('');
		setLoading(false);
	};

	const onConfirmClick = async () => {
		setLoading(true);
		const success = await handleConfirm(createKey, createValue);

		if (success) {
			closeAndClear();
		} else {
			setLoading(false);
		}
	};

	const onCloseClick = () => {
		closeAndClear();
	};

	const keyErrors = getKeyErrors(createKey);
	const confirmDisabled = loading || !isFormValid || !keyErrors.isValid;

	const actions: Action[] = [
		{ text: 'Confirm', disabled: confirmDisabled, onClick: onConfirmClick },
		{ text: 'Cancel', disabled: loading, onClick: onCloseClick },
	];

	return (
		<DefaultDialog
			actions={actions}
			open={isOpen}
			onClose={close}
			title={title}
		>
			<Wrapper>
				<div style={{ display: 'flex', flexDirection: 'column' }}>
					<TextField
						id='createKey'
						style={{ marginRight: '10px', marginTop: '5px' }}
						label={'Key'}
						value={createKey}
						onChange={(e) => setCreateKey(e.target.value)}
						disabled={!!editKey}
						error={!keyErrors.isValid}
						helperText={!keyErrors.isValid ? keyErrors.message : null}
					/>
					<TextField
						id='createValue'
						style={{ marginRight: '10px', marginTop: '5px' }}
						label={'Value'}
						value={createValue}
						onChange={(e) => setCreateValue(e.target.value)}
						multiline
						rows={4}
					/>
				</div>
			</Wrapper>
		</DefaultDialog>
	);
};

const validKeyRegex = new RegExp('^[a-zA-Z0-9-_~]+$');
export const getKeyErrors = (createKey: string) => {
	const keyErrors = { isValid: true, message: '' };

	if (createKey === '') {
		return keyErrors;
	} else if (createKey?.length > 256) {
		keyErrors.isValid = false;
		keyErrors.message = 'Key size must be between 1 and 256';
	} else if (!validKeyRegex.test(createKey)) {
		keyErrors.isValid = false;
		keyErrors.message = 'Key must match "^[a-zA-Z0-9-_~]+$"';
	}

	return keyErrors;
};

const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	margin-left: 30px;
	width: 80%;
`;

export default AuxDataModal;
